import React from 'react';
import store from '../store/store';
import { loadUsers } from '../store/actions/actions';
import { HashRouter, Redirect, Route } from 'react-router-dom';

import './app.scss';

import Card from '../models/card';

import Nav from './nav/nav';
import Game from './game/game';
import Stats from './stats/stats';
import Header from './header/header';
import Footer from './footer/footer';

async function loadCards(): Promise<Card[]> {
  const cards: Card[] = await fetch('data/cards.json').then((data) => data.json());
  return cards;
}

type State = {
  cards: Card[];
};

class App extends React.Component {
  state: State = {
    cards: [],
  };

  componentDidMount() {
    loadCards().then((cards: Card[]) => this.setState({ cards }));
    store.dispatch(loadUsers());
  }

  render() {
    return (
      <div className="app">
        <HashRouter>
          <Header>
            <Nav />
          </Header>
          <Route exact path="/" render={() => <Redirect to="/game" />} />
          <Route exact path="/game" render={() => <Game cards={this.state.cards} />} />
          <Route exact path="/stats" render={() => <Stats />} />
          <Footer />
        </HashRouter>
      </div>
    );
  }
}

export default App;
